export enum InitialLoadIconsSet {
  RIGHT_ARROW = '\\43',
  LANGUAGE = '\\6c',
  SHOW_MORE = 'J',
  CLOSE = 'H',
  RIGHT_CHEVRON = 'a',
  USER = 'p',
  EXPAND_MORE = '\\4a',
  USER_PROFILE = '\\70',
  REMOVE_FROM_WATCHLIST = 'w',
  ADD_TO_WATCHLIST = 'W',
  VIEW_ALL = '\\61',
  SEARCH = '\\4d',
  MIC = '\\34',
  MORE_MENU = '\\42',
  HAMBURGER_MENU = 'K',
  CROWN = 'P',
  CHEVRON = 'J',
  ARROW = '\\41',
  PLUS = '+',
  MINUS = '-',
  TIMER = '\\74'
}

export enum OtherIconsSet {
  CHECK_MARK = 'G',
  TICK = 'c',
  EDIT = 'p',
  TOP_CHEVRON = 'I',
  FALLBACK_PAGE_ICON = 'w',
  SAD_ICON = '\\73',
  INSTAGRAM = 'z',
  YOUTUBE = 'y',
  BACK_ARROW = '\\41',
  MIC = '\\35',
  FACEBOOK = '\\33',
  TWITTER = '\\68',
  MAIL = '\\34',
  WHATSAPP = '\\57',
  ARROW = 'A',
  INFO = '\\69',
  UP_ARROW = '\\49',
  LEFT_ARROW_CHEVRON = '\\62',
  BELL = 'R',
  PAYMENT_SUCCESS_ICON = '\\63',
  WARNING_ICON = '\\0021'
}

export enum NewIconsSet {
  SHARE = '\\25',
  SEARCH = 'S'
}

export enum IconsSetType {
  INITIAL_LOAD = 'initial',
  OTHERS = 'others',
  ZEE5_PLAYER = 'zee5_player',
  NEW = 'new',
  LIKE_DISLIKE = 'like_dislike',
  COMMERCE = 'commerce'
}

export enum Zee5PlayerIconsSet {
  PLAY = '\\70'
}

export enum PlayerIconsSet {}

export enum LikeDislikeIconsSet {
  LIKE_FILLED = 'c',
  DISLIKE_FILLED = 'b',
  LIKE_OUTLINED = 'd',
  DISLIKE_OUTLINED = 'a'
}

export enum CommerceIconsSet {
  WISHLIST = '\\24',
  WISHLISTED = '\\32',
  CLOSE = '\\69',
  SHOP = '\\3d'
}
